<template lang="html">
  <div class="profile-notifications-wrapper">
    <div class="tabs-wrapper">
      <div
        @click="currentTab = 1"
        class="tab"
        :class="{ active: currentTab === 1 }">
        <span style="position: relative;">
          {{this.$t('profile.notifications.notifications')}}
          <notification-counter v-if="notificationsCount > 0" :counter="notificationsCount" />
        </span>
      </div>
      <div
        @click="currentTab = 2"
        class="tab"
        :class="{ active: currentTab === 2 }">
        <span style="position: relative;">
          {{this.$t('profile.notifications.messages')}}
          <notification-counter v-if="messagesCount > 0" :counter="messagesCount" />
        </span>
      </div>
    </div>
    <component v-bind:is="currentTabComponent"></component>
  </div>
</template>

<script>
import NotificationCounter from '@/components/notificationCounter.vue'
import Notifications from '@/components/profile/notifications.vue'
import Messages from '@/components/profile/messages.vue'
import { mapState } from 'vuex'
export default {
  name: 'profileNotifications',
  components: {
    Notifications,
    Messages,
    NotificationCounter
  },
  data () {
    return {
      tabs: [
        { label: this.$t('profile.notifications.notifications'), value: 1, counter: 'notificationsCount' },
        { label: this.$t('profile.notifications.messages'), value: 2, counter: 'messagesCount' }
      ],
      currentTab: 1
    }
  },
  computed: {
    ...mapState(['notificationsCount', 'messagesCount']),
    currentTabComponent () {
      if (this.currentTab === 1) {
        return Notifications
      } else {
        return Messages
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-notifications-wrapper {
  padding-left: 40px;
  .tabs-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .tab {
      padding: 0px 30px;
      padding-bottom: 5px;
      height: 30px;
      line-height: 30px;
      margin-bottom: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 1px 0px 0px #EEEEEE;
      -moz-box-shadow: 0px 1px 0px 0px #EEEEEE;
      box-shadow: 0px 1px 0px 0px #EEEEEE;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.06em;
      color: #898989;
    }
    .tab.active {
      -webkit-box-shadow: 0px 2px 0px 0px $main-color;
      -moz-box-shadow: 0px 2px 0px 0px $main-color;
      box-shadow: 0px 2px 0px 0px $main-color;
      color: $main-color;
    }
    .tab:first-child {
      margin-left: 0;
    }
    .tab:last-child {
      margin-right: 0;
    }
  }
}
@media screen and (max-width: 1000px ) {
  .profile-notifications-wrapper {
    padding-left:  5px;
  }
}
</style>
